import { useState } from 'react';
import { FaCode, FaPaintBrush, FaSearch } from 'react-icons/fa';
const { FaBullhorn, FaVideo, FaUsers } = require('react-icons/fa');

const iconColor = '#ed4e01';

const services = [
    {
        title: 'Digital Strategy',
        description: 'We create tailored digital strategies that align with your business goals, connect with your audience, and maximize your online impact. From social media planning to content mapping, every strategy is designed for measurable results.',
        icon: <FaPaintBrush size={40} color={iconColor} />,
    },
    {
        title: 'Web Development',
        description: 'We design and develop websites that are visually striking, user-friendly, and optimized for performance. Our approach combines creativity with functionality to deliver a seamless digital experience that reflects your brand identity.',
        icon: <FaCode size={40} color={iconColor} />,
    },
    {
        title: 'SEO Optimization',
        description: 'We improve your online visibility by optimizing your website and content for search engines. Our SEO strategies help attract organic traffic, boost rankings, and increase conversions through data-driven techniques.',
        icon: <FaSearch size={40} color={iconColor} />,
    },
    {
        title: 'Paid Media',
        description: 'We plan and manage targeted paid campaigns across platforms like Google, Facebook, and Instagram. Our approach ensures every advertising dollar is invested efficiently to drive leads, engagement, and ROI.',
        icon: <FaBullhorn size={40} color={iconColor} />,
    },
    {
        title: 'Content Creation',
        description: 'We produce high-quality, engaging content tailored to your brand and audience. From graphics and videos to social media posts, our content is designed to inform, inspire, and convert.',
        icon: <FaVideo size={40} color={iconColor} />,
    },
    {
        title: 'PR and Influencer Marketing',
        description: 'We build brand awareness and credibility through strategic public relations campaigns and influencer collaborations. By connecting with the right voices, we amplify your message and create meaningful audience engagement.',
        icon: <FaUsers size={40} color={iconColor} />,
    }
];

export default function OurServicesComponent(){
     const [hoveredIdx, setHoveredIdx] = useState(null);

    return (
        <div style={{ marginTop: '4rem', marginBottom: '4rem', padding: '2rem' }}>
            <p style={{ color: "#0000FF", textAlign: "center", letterSpacing: "3px", fontSize: "40px" }}>Our Services:</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '2rem', justifyContent: 'center' }}>
                {services.map((service, idx) => (
                    <div
                        key={idx}
                        onMouseEnter={() => setHoveredIdx(idx)}
                        onMouseLeave={() => setHoveredIdx(null)}
                        style={{
                            border: '1px solid #ddd',
                            borderRadius: '8px',
                            borderTop: '6px solid #0000FF', // borde superior azul
                            padding: '1.5rem',
                            width: hoveredIdx === idx ? '280px' : '250px',
                            background: '#fafafa',
                            boxShadow: hoveredIdx === idx
                                ? '0 4px 16px rgba(0,0,0,0.10)'
                                : '0 2px 8px rgba(0,0,0,0.05)',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center',
                            transition: 'all 0.2s cubic-bezier(.4,2,.6,1)',
                            zIndex: hoveredIdx === idx ? 1 : 0,
                            backgroundColor: hoveredIdx === idx ? '#F5F5DC' : '#F5F5DC',
                        }}
                    >
                        {service.icon}
                        <h2 style={{ marginTop: 15, color: "#0000FF", letterSpacing: "2px", fontWeight: "bold" }}>{service.title}</h2>
                        <p style={{ color: "#0000FF", letterSpacing: "1px", fontWeight: "bold" }}>{service.description}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}


      
